import {STYLE_INJECTION_MIXIN} from "../mixins/style-injection-mixin";
import IconTooltip from "../views/builder/misc/IconTooltip";
import { langSuffix, LANGUAGE_CONFIG } from "../utils/languageHelper";


const CONTROL_SPECIAL_CONFIG_MIXIN = {
    components: {IconTooltip},
    mixins: [STYLE_INJECTION_MIXIN],

    props: {
        /**
         * Control Object Configuration
         */
        control: {
            type: Object,
            required: true
        },

        /**
         * Form-Data from the ROOT
         */
        formData: {
            type: Object,
            required: true
        },

        /**
         * Site ID
         */
        siteID: {
            type: String,
            default: ''
        }
    },

    computed: {
        /**
         * Enabled non-English translation languages for this form.
         * Each entry: { code: 'es', name: 'Español', suffix: 'Es' }
         */
        enabledTranslationLanguages() {
            if (!this.formData || !this.formData.formConfig) return [];
            const supported = this.formData.formConfig.supportedLanguages || [];
            return supported
                .filter(code => code !== 'en' && LANGUAGE_CONFIG[code])
                .map(code => ({ code, name: LANGUAGE_CONFIG[code].name, suffix: langSuffix(code) }));
        },

        /**
         * @deprecated Use enabledTranslationLanguages instead
         * Kept for backward compat — true if ANY translation language is enabled
         */
        spanishEnabled() {
            return this.enabledTranslationLanguages.length > 0;
        }
    }
}

export{
    CONTROL_SPECIAL_CONFIG_MIXIN
}
